// src/components/HeaderComponents/GimManagerInstallButton.jsx

import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { logDebug } from '@/shared/config/globalFunctions';

/**
 * Clean, Redux-driven GIMmanager Install/Update Button
 * @param {{
 *   showInstallerButton: boolean,
 *   appUpdateAvailable: boolean,
 *   latestAppVersion: string,
 *   t: function,
 *   show: boolean,
 *   onInstallClick: () => void,
 *   onUpdateClick: () => void
 * }} props
 * @returns {import('react').ReactElement}
 */
const GimManagerInstallButton = ({
  showInstallerButton,
  appUpdateAvailable,
  latestAppVersion,
  t,
  show,
  onInstallClick,
  onUpdateClick,
}) => {
  logDebug(
    `show? ${show}, appUpdateAvailable? ${appUpdateAvailable}, showInstallerButton? ${showInstallerButton}`
  );
  // Don't render button at all if not allowed by parent (Header)
  if (!show) return null;

  // Show the Install button if the installer should be shown
  if (showInstallerButton) {
    return (
      <Button
        id="InstallGIMmanager"
        className="download-exe flex-shrink-0"
        variant="secondary"
        onClick={onInstallClick}
      >
        <FontAwesomeIcon
          id="InstallGIMmanagerIcon"
          icon={faDownload}
          role="button"
          style={{ marginRight: 10 }}
        />
        <span>{t('Header.InstallGIMmanager')}</span>
        {latestAppVersion && (
          <span style={{ marginLeft: 6 }}>{latestAppVersion}</span>
        )}
      </Button>
    );
  }

  // Show the Update button if an update is available (and install is not showing)
  if (appUpdateAvailable) {
    return (
      <Button
        id="UpdateGIMmanager"
        className="download-exe flex-shrink-0"
        variant="dark"
        onClick={onUpdateClick}
      >
        <FontAwesomeIcon
          id="UpdateGIMmanagerIcon"
          icon={faDownload}
          role="button"
          style={{ marginRight: 10 }}
        />
        <span>{t('Header.downloadUpdate')}</span>
        {latestAppVersion && (
          <span style={{ marginLeft: 6 }}>{latestAppVersion}</span>
        )}
      </Button>
    );
  }

  // Otherwise, show nothing
  return null;
};

export default GimManagerInstallButton;
